import * as React from 'react';

import {IconOnlyButton} from '../../button/icon-only-button/icon-only-button';
import {NavIconChevronLeftIcon} from '../../icon/navigation/nav-icon-chevron-left';
import {NavIconChevronRightIcon} from '../../icon/navigation/nav-icon-chevron-right';

type Props = {
    onClick: () => void;
    direction: 'left' | 'right';
    disabled: boolean;
};

export function ScrollButton(props: Props) {
    const icon = props.direction === 'left' ? NavIconChevronLeftIcon : NavIconChevronRightIcon;

    return (
        <IconOnlyButton
            onClick={props.onClick}
            // @ts-expect-error
            disabled={props.disabled}
            icon={icon}
            size='large'
        />
    );
}
